<template>
    <div>
        <vs-card class="p-4">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Replenish Details</h4>
                </div>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" :disabled="data.details.length < 1" @click="submitForm" icon="save">Save</vs-button>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Replenish ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Replenish Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.date"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Replenish Type*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.replenish_type_id"
                                width="100%"
                                autocomplete
                                :disabled="data.details.length > 0"
                            >
                                <vs-select-item v-for="(item, index) in type" :key="index" :value="item.value" :text="item.label"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                                :disabled="data.details.length > 0"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.warehouse_id"
                                width="100%"
                                autocomplete
                                :disabled="data.details.length > 0"
                                @input-change="searchDropdown($event, warehouse)"
                            >
                                <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details">
                    <vs-button class="mr-4 mt-3" type="border" :disabled="!data.replenish_type_id || !data.client_id || !data.warehouse_id" @click="refresh">Refresh</vs-button>
                    <vs-button type="border" @click="clear">Clear</vs-button>
                    <div style="max-height: 400px; overflow-x: auto" class="mt-3">
                        <vs-table multiple v-model="selected" :data="data.details" hoverFlat>
                            <template slot="thead">
                                <vs-th>Line ID</vs-th>
                                <vs-th>Product ID</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Exp. Date</vs-th>
                                <vs-th>Base Qty</vs-th>
                                <vs-th>Base UoM</vs-th>
                                <vs-th>Stock Type</vs-th>
                                <vs-th>Src. Loc. Type</vs-th>
                                <vs-th>Src. Loc. ID</vs-th>
                                <vs-th>Dest. Loc. Type</vs-th>
                                <vs-th>Dest. Loc. ID</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" >
                                    <vs-td>{{ detail.line_id }}</vs-td>
                                    <vs-td>{{ detail.product_code }}</vs-td>
                                    <vs-td>{{ detail.description_1 }}</vs-td>
                                    <vs-td>{{ detail.pack_id }}</vs-td>
                                    <vs-td>{{ detail.batch }}</vs-td>
                                    <vs-td>{{ detail.expired_date }}</vs-td>
                                    <vs-td>{{ detail.base_qty }}</vs-td>
                                    <vs-td>{{ detail.base_uom_name }}</vs-td>
                                    <vs-td>{{ detail.stock_type_name }}</vs-td>
                                    <vs-td>{{ detail.source_location_type }}</vs-td>
                                    <vs-td>{{ detail.source_location_code }}</vs-td>
                                    <vs-td>{{ detail.destination_location_type }}</vs-td>
                                    <vs-td>{{ detail.destination_location_code }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                    <vs-textarea label="Note" height="200"/>
                </vs-tab>
                <vs-tab label="Attachment" class="pt-base">
                    <vs-row class="w-full">
                        <vs-button class="mr-4" type="border">Add</vs-button>
                        <vs-button class="mr-4" type="border">Remove</vs-button>
                    </vs-row>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            selected: [],
            data: {
                id: '',
                reference: '',
                date: new Date,
                replenish_type_id: 1,
                client_id: this.$store.state.user.userconfig.client_id ? this.$store.state.user.userconfig.client_id : null,
                warehouse_id: this.$store.state.user.userconfig.warehouse_id ? this.$store.state.user.userconfig.warehouse_id : null,
                details: [],
            },
            type: [
                {
                    value: 1,
                    label: 'ROP'
                }
            ],
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({name: 'replenish'})
        },
        fetchData() {
            this.isLoading = true
            Promise.all([this.$http.post('master/clients'), this.$http.post('master/warehouses')])
            .then(this.$http.spread((clients, warehouses) => {
                this.client.data = clients.data.data
                this.warehouse.data = warehouses.data.data
                this.pushClientWarehouse(this.client.data, this.warehouse.data)
                this.isLoading = false
            }))
            .catch(error => {
                this.isLoading = false
                console.log(error)
            })
        },
        submitForm() {
            let error = false
            let ids = []

            const replenishHead = {
                reference: this.data.reference,
                date: this.data.date,
                replenish_type_id: this.data.replenish_type_id,
                client_id: this.data.client_id,
                warehouse_id: this.data.warehouse_id,
            }

            if(this.selected.length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: `No data selected.`
                })
                error = false
            }

            this.selected.map(item => {
                if(!item.inventory_first_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Line ${item.line_id} - No location ID assigned.`
                    })
                    error = false
                }
                else {
                    ids.push(item.draft_id)
                }
            })

            if(error) {
                return false
            }

            const dataSend = {
                reference: this.data.reference,
                date: this.data.date,
                replenish_type_id: this.data.replenish_type_id,
                client_id: this.data.client_id,
                warehouse_id: this.data.warehouse_id,
                details: ids
            }

            this.isLoading = true
            this.$http.post('inventories/replenish/store', dataSend)
            .then(res => {
                this.isLoading = false

                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Store successfully.'
                })

                this.$router.push({
                    name: 'replenish-view',
                    params: {
                        id: res.data.replenish_id
                    }
                })
            })
            .catch(error => this.handleError(error))
        },
        refresh() {
            const data = {
                warehouse_id: this.data.warehouse_id,
                client_id: this.data.client_id,
            }

            this.isLoading = true
            this.$http.post('inventories/replenish/refresh', data)
            .then(res => {
                this.selected = []
                this.data.details = []
                res.data.pick_movement.map((item, index) => {
                    item.line_id = index + 1
                    this.data.details.push(item)
                    if(item.inventory_first_id) {
                        this.selected.push(item)
                    }
                })
                this.isLoading = false
                this.assignLineId()
            })
            .catch(error => this.handleError(error))
        },
        assignLineId() {
            this.data.details.map((item, index) => {
                item.line_id = index + 1
            })
        },
        clear() {
            this.data.details = []
            this.selected = []
        }
    },
    mounted() {
        this.fetchData()
    }
};
</script>